import { ModalFooter, Button, Flex, Text } from "@chakra-ui/react";
import { pxToRem } from "../../../utils/styles/size";

const ConfirmPopupActions = ({
  onCancel,
  onDontSend,
  onConfirm,
  cancelLabel,
  dontSendLabel,
  confirmLabel,
}: {
  onCancel: () => void;
  onDontSend?: () => void;
  onConfirm: () => void;
  cancelLabel: string;
  dontSendLabel?: string;
  confirmLabel: string;
}) => {
  return (
    <ModalFooter
      p={2.5}
      h="max-content"
    >
      <Flex
        w="100%"
        justify="flex-end"
        gap={2.5}
      >
        <Button
          onClick={onCancel}
          bg="--hover-big"
          borderRadius="6px"
          w={pxToRem(110)}
          h={9}
          px={8}
          py={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          boxSizing="border-box"
          color="--project-default-grey"
          _hover={{ color: "#fff", bg: "--w-8_hover" }}
        >
          <Text textStyle="body1">{cancelLabel}</Text>
        </Button>
        {dontSendLabel && onDontSend && (
          <Button
            onClick={onDontSend}
            bg="--hover-big"
            borderRadius="6px"
            w={pxToRem(110)}
            h={9}
            px={8}
            py={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            boxSizing="border-box"
            color="--project-default-grey"
          >
            <Text textStyle="body1">{dontSendLabel}</Text>
          </Button>
        )}
        <Button
          onClick={onConfirm}
          bg="--w-16"
          borderRadius="5px"
          w={pxToRem(110)}
          h={9}
          px={8}
          py={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          boxSizing="border-box"
          color="white"
          _hover={{ bg: "--w-24" }}
        >
          <Text textStyle="body1">{confirmLabel}</Text>
        </Button>
      </Flex>
    </ModalFooter>
  );
};

export default ConfirmPopupActions;
